/* eslint-disable @typescript-eslint/no-unsafe-return */
import { styled, type Theme } from '@elliemae/ds-system';
import { Grid } from '@elliemae/ds-grid';
import { DSButtonV2 } from '@elliemae/ds-button-v2';
import { DSLeftNavigationName, LEFT_NAVIGATION_SLOTS } from '../constants/index.js';
import type { DSLeftNavigationT } from '../react-desc-prop-types.js';
type ColorsKey = keyof Theme['colors'];

interface StyledLabelT {
  labelBold?: boolean;
  labelOverflow?: string;
  labelColor?: [ColorsKey, keyof Theme['colors'][ColorsKey]];
}

export const StyledLabel = styled(Grid, {
  name: DSLeftNavigationName,
  slot: LEFT_NAVIGATION_SLOTS.ITEM_LABEL,
})<StyledLabelT>`
  font-size: 1rem; // 13px -> 13/13 = 1rem;
  font-weight: ${(props) => (props.labelBold ? props.theme.fontWeights.semibold : props.theme.fontWeights.regular)};
  color: ${({ labelColor, theme }) =>
    labelColor ? theme.colors[labelColor[0]][labelColor[1]] : theme.colors.neutral[800]};
  line-height: 1.0769rem; // 14px -> 14/13 = 1.0769rem
  word-break: ${(props) => (props.labelOverflow === 'wrapAll' ? 'break-all' : 'normal')};
  @media (max-width: ${({ theme }) => theme.breakpoints.small}) {
    font-size: 0.8125rem; // 16px -> 13/16 = 0.8125
    line-height: 0.875rem; // 14px -> 14/16 = 0.875rem
  }
`;

export const StyledDate = styled(Grid, { name: DSLeftNavigationName, slot: LEFT_NAVIGATION_SLOTS.ITEM_DATE })`
  font-size: 0.923rem; // 12px -> 12/13 = 0.9230rem
  color: ${(props) => props.theme.colors.neutral[600]};
  line-height: 1.0769rem; // 14px -> 14/13 = 1.0769rem
  @media (max-width: ${({ theme }) => theme.breakpoints.small}) {
    font-size: 0.75rem; // 12px -> 12/16 = 0.75rem
    line-height: 0.875rem; // 14px -> 14/16 = 0.875rem
  }
`;

export const StyledArrowContainer = styled(Grid, {
  name: DSLeftNavigationName,
  slot: LEFT_NAVIGATION_SLOTS.ARROW_CONTAINER,
})``;

export const StyledRightContainer = styled(Grid, {
  name: DSLeftNavigationName,
  slot: LEFT_NAVIGATION_SLOTS.RIGHT_CONTAINER,
})``;

export const StyledSectionLabel = styled('span', {
  name: DSLeftNavigationName,
  slot: LEFT_NAVIGATION_SLOTS.SECTION_LABEL,
})`
  font-size: 1rem; // 13px -> 13/13 = 1rem
  color: ${(props) => props.theme.colors.neutral[700]};
  margin-left: ${(props) => props.theme.space.xxs};
  line-height: 1rem; // 13px -> 13/13 = 1rem
  @media (max-width: ${({ theme }) => theme.breakpoints.small}) {
    font-size: 0.8125rem; // 13px -> 13/16 = 0.8125rem
    line-height: 0.8125rem; // 13px -> 13/16 = 0.8125rem
  }
`;

export const StyledVerticalSeparator = styled('div', {
  name: DSLeftNavigationName,
  slot: LEFT_NAVIGATION_SLOTS.VERTICAL_SEPARATOR,
})`
  margin: 0 ${(props) => props.theme.space.xxs};
  width: 1px;
  height: 13px;
  background: ${(props) => props.theme.colors.neutral[600]};
`;

export const StyledRightLabel = styled('span', {
  name: DSLeftNavigationName,
  slot: LEFT_NAVIGATION_SLOTS.SECTION_RIGHT_LABEL,
})`
  font-size: 0.923rem; // 12px -> 12/13 = 0.9230rem;
  line-height: 1rem; // 13px -> 13/13 = 1rem
  @media (max-width: ${({ theme }) => theme.breakpoints.small}) {
    font-size: 0.75rem; // 12px -> 12/16 = 0.75rem
    line-height: 0.8125rem; // 13px -> 13/16 = 0.8125rem
  }
`;

export const StyledSectionContainer = styled(Grid, {
  name: DSLeftNavigationName,
  slot: LEFT_NAVIGATION_SLOTS.SECTION_CONTAINER,
})``;

export const StyledBottomContainer = styled(Grid, {
  name: DSLeftNavigationName,
  slot: LEFT_NAVIGATION_SLOTS.BOTTOM_CONTAINER,
})`
  grid-column: span 3;
`;

export const StyledLeftContainer = styled(Grid, {
  name: DSLeftNavigationName,
  slot: LEFT_NAVIGATION_SLOTS.LEFT_CONTAINER,
})``;

export const StyledItemLabel = styled(Grid, { name: DSLeftNavigationName, slot: LEFT_NAVIGATION_SLOTS.ITEM_LABEL })<{
  labelOverflow?: DSLeftNavigationT.LabelOveflowT;
}>`
  font-size: 1.0769rem; // 14px -> 14/13 = 1.0769rem
  color: ${(props) => props.theme.colors.neutral[800]};
  word-break: ${(props) => (props.labelOverflow === 'wrapAll' ? 'break-all' : 'normal')};
  @media (max-width: ${({ theme }) => theme.breakpoints.small}) {
    font-size: 0.875rem; // 14px -> 14/16 = 0.875rem
  }
`;

export const StyledChevronLeft = styled(DSButtonV2, {
  name: DSLeftNavigationName,
  slot: LEFT_NAVIGATION_SLOTS.ITEM_CHEVRON_BACK,
})`
  padding: 0;
  :focus {
    outline: 2px solid ${(props) => props.theme.colors.brand[800]};
  }
`;
